import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Nav from './components/portfolio/Nav';
import Hero from './components/portfolio/Hero';
import WorksGallery from './components/portfolio/WorksGallery';
import ProfileSection from './components/portfolio/ProfileSection';
import ActivitiesSection from './components/portfolio/ActivitiesSection';
import OrderSection from './components/portfolio/OrderSection';
import LessonSection from './components/portfolio/LessonSection';
import ContactSection from './components/portfolio/ContactSection';
import Footer from './components/portfolio/Footer';
import AdminPage from './components/admin/AdminPage';
import './styles/portfolio.css';

function PortfolioPage() {
  return (
    <div className="pf-page">
      <Nav />
      <Hero />
      <WorksGallery />
      <ProfileSection />
      <ActivitiesSection />
      <OrderSection />
      <LessonSection />
      <ContactSection />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PortfolioPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
